// extracted by mini-css-extract-plugin
export default {"videoResponsive":"cjqjulirv"};